import React from 'react';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import styles from './WalletDetails.module.css';

const transactions = [
  { id: 1, dateGroup: 'TODAY, JAN 30', title: 'Professional Plan - Monthly', time: '09:12 AM', amount: '₦25,000.00', status: 'SUCCESS', tx: 'TXN-9982471' },
  { id: 2, dateGroup: 'TODAY, JAN 30', title: 'Wallet Funding Via Paystack', time: '08:47 AM', amount: '₦55,000.00', status: 'SUCCESS', tx: 'TXN-9982570' },
  { id: 3, dateGroup: 'DEC 25, 2025', title: 'Professional Plan - Monthly', time: '09:12 AM', amount: '₦25,000.00', status: 'SUCCESS', tx: 'TXN-9982471' },
  { id: 4, dateGroup: 'DEC 25, 2025', title: 'Wallet Funding Via Bank Transfer', time: '08:47 AM', amount: '₦30,000.00', status: 'SUCCESS', tx: 'TXN-9982570' },
];

export default function WalletDetails() {
  return (
    <div>
      <HeaderNav />
      <main className={styles.container}>
        <div className={styles.headerRow}>
          <a className={styles.back} href="/dashboard">← Back to Dashboard</a>
          <h1 className={styles.title}>Wallet Details</h1>
        </div>

        <div className={styles.grid}>
          <aside className={styles.leftCard}>
            <div className={styles.balanceBox}>
              <div className={styles.balanceLabel}>AVAILABLE BALANCE</div>
              <div className={styles.balance}>₦30,000.00</div>
            </div>

            <div className={styles.infoList}>
              <div className={styles.infoItem}>
                <div className={styles.infoLabel}>Wallet Name</div>
                <div className={styles.infoValue}>Johnson Ojo</div>
              </div>
              <div className={styles.infoItem}>
                <div className={styles.infoLabel}>Wallet ID</div>
                <div className={styles.infoValue}>0123456789</div>
                <button className={styles.copy}>Copy</button>
              </div>
              <div className={styles.infoItem}>
                <div className={styles.infoLabel}>Wallet Status</div>
                <div className={styles.status}>ACTIVE</div>
              </div>
            </div>

            <div className={styles.fundBtnWrap}>
              <a href="/wallet/fund" className={styles.fundButton}>Fund Wallet</a>
            </div>
          </aside>

          <section className={styles.rightColumn}>
            <div className={styles.tabs}>
              <button className={`${styles.tab} ${styles.active}`}>All Transactions</button>
              <button className={styles.tab}>Deposits</button>
              <button className={styles.tab}>Payment</button>
            </div>

            <div className={styles.transactions}>
              {transactions.map((t) => (
                <div key={t.id} className={styles.txCard}>
                  <div className={styles.txLeft}>
                    <div className={styles.txIcon} />
                    <div>
                      <div className={styles.txTitle}>{t.title} <span className={styles.txStatus}>{t.status}</span></div>
                      <div className={styles.txTime}>{t.time}</div>
                    </div>
                  </div>
                  <div className={styles.txRight}>
                    <div className={styles.txAmount}>{t.amount}</div>
                    <div className={styles.txRef}>{t.tx}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
